import { render, staticRenderFns } from "./BusConnection.vue?vue&type=template&id=36f582ee&scoped=true"
import script from "./BusConnection.vue?vue&type=script&lang=js"
export * from "./BusConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f582ee",
  null
  
)

export default component.exports